import $ from 'jquery';
import FormDisabler from '@/lib/form-disabler.js';
import ScoringCriterionFormWrapper from '@/modules/scoring-criteria/components/ScoringCriterionFormWrapper.vue';
import store from '@/lib/store/index.js';
import Vue from 'vue';

export default function () {
	if (document.getElementById('scoring-criterion-form-wrapper')) {
		const scoringCriterionForm = new Vue({
			el: '#scoring-criterion-form-wrapper',
			name: 'ScoringCriterionFormApp',
			components: {
				scoringCriterionFormWrapper: ScoringCriterionFormWrapper,
			},
			store,
		});

		new FormDisabler().disableForm($('.form-disabled'));

		$(document).one('pjax:end', () => {
			scoringCriterionForm.$destroy();
		});
	}
}
